
import { styled } from '@mui/material';
import EDBox from '../../EDBox/EDBox';
import { spacing, SpacingProps } from '@mui/system';

interface IProps extends SpacingProps {
  displayFlex?: boolean;
  testId?: string;
}

/**
 * Motsvarande standardkort, men anpassad för att visas som del av en dialog
 *
\• noPadding visar kortet utan padding
 *
 */
const EDDialogCardUnstyled: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { displayFlex, ...rest } = props;
  return (
    <EDBox
      sx={[
        {
          borderRadius: theme => theme.spacing(0.5),
          flex: 1,
          background: theme => theme.palette.grey[100],
          boxShadow: 0,
          border: 1,
          borderColor: theme => theme.palette.grey[300],
          overflow: 'auto',
          padding: 2,
        },
        Boolean(props.displayFlex) && {
          display: 'flex',
          flexDirection: 'column',
        },
      ]}
      testID={props.testId}
      {...rest}
    ></EDBox>
  );
};

export const EDDialogCard: React.FC<React.PropsWithChildren<IProps>> = styled(
  EDDialogCardUnstyled,
  {
    name: 'EDDialogCard',
  }
)(spacing);
